import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FocusTrapDirective } from '../directives/focus-trap.directive';

/**
 * Shared chrome for a bottom-sheet-on-mobile / centered-dialog-on-desktop
 * modal: backdrop, rounded panel, pull handle, and focus trap. Modeled on
 * `ConfirmDialogComponent` but for the larger, richer dialogs (id verify,
 * message host, POI detail) that own their own header/body/footer via
 * `<ng-content>` — this component only owns the shell those duplicated.
 *
 * Backdrop click and Escape both emit `(dismissed)`; callers decide what
 * that means (e.g. id-verify-modal shows a loss-guard prompt instead of
 * closing outright when the guest has unsaved uploads).
 */
@Component({
  selector: 'cnt-bottom-sheet-modal',
  standalone: true,
  imports: [FocusTrapDirective],
  templateUrl: './bottom-sheet-modal.component.html',
  styleUrls: ['./bottom-sheet-modal.component.scss'],
})
export class BottomSheetModalComponent {
  @Input() open = false;
  /** Id of the heading inside the projected content, wired to aria-labelledby. */
  @Input() ariaLabelledBy = '';

  @Output() dismissed = new EventEmitter<void>();

  onDismiss(): void {
    this.dismissed.emit();
  }
}
